<template>
  <v-dialog v-model="localDialog" max-width="500" content-class="card card-sm">
    <h4>{{ $t("appname") }}</h4>
    <k-spacing y="4"></k-spacing>
    <v-form ref="form" @submit.prevent="createapp" v-model="isValid" lazy-validation>
      <v-text-field v-model="app.name" required hide-details density="compact" variant="solo"></v-text-field>
      <div class="d-flex pt-4 text-right ml-auto">
        <v-btn class="btn btn-sm mr-2" color="var(--neutral)" variant="text" @click="$emit('close')">{{ $t("cancel")
          }}</v-btn>
        <v-btn :disabled="!isValid" class="btn btn-sm text-white" color="var(--primary)" elevation="0"
          @click="createapp" :loading="creating">
          {{ $t("create") }}
        </v-btn>
      </div>
    </v-form>
  </v-dialog>
</template>

<script>
import config from "@/config";
import { mapState } from "pinia";
import { useMainStore } from "@/stores/store";
import api from "@/services/api";

export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    config: config,
    app: {
      color: "#ddf0f6", // Default color value
      description: "", // Default description value
      icon: "https://cdn.kyano.app/img/kyano-sites-icon-dark.svg", // Default icon value
      name: "", // Default name value
    },

    afbeeldingen: [
      {
        url: "https://cdn.kyano.app/img/kyano-account-icon-dark.svg",
        color: "#5856d6",
        naam: "Afbeelding 1",
      },
      {
        url: "https://cdn.kyano.app/img/kyano-forms-icon-dark.svg",
        color: "#31be55",
        naam: "Afbeelding 2",
      },
      {
        url: "https://cdn.kyano.app/img/kyano-sites-icon-dark.svg",
        color: "#24a1c7",
        naam: "Afbeelding 3",
      },
      {
        url: "https://cdn.kyano.app/img/kyano-servicedesk-icon-dark.svg",
        color: "#ff9500",
        naam: "Afbeelding 4",
      },
    ],

    geselecteerdeAfbeelding: null,
    localDialog: false,
    creating: false,
    isValid: false,
  }),

  computed: {
    ...mapState(useMainStore, ["user", "workspaces", "kyano"]),
  },
  watch: {
    value(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    kiesRandomAfbeelding() {
      const index = Math.floor(Math.random() * this.afbeeldingen.length);
      this.geselecteerdeAfbeelding = this.afbeeldingen[index];
    },

    async createapp() {
      if (!this.$refs.form.validate()) {
        this.$toast.error("Please fill out the form correctly.");
        return;
      }

      this.kiesRandomAfbeelding();

      try {
        const spaceData = {
          ...this.app,
          owner_id: this.user.id,
          workspace_id: this.user.active_workspace_id,
          icon: this.geselecteerdeAfbeelding.url,
          color: this.geselecteerdeAfbeelding.color,
        };
        this.creating = true;

        const response = await api.post(`/api/v1/apps`, spaceData);
        this.$toast.success("App created successfully!");
        const app_id = response.data.data.id;
        if (app_id) {
          this.$router.push(`/app/${app_id}/layout`);
        }
        this.resetDialog();
        this.app = {
          name: "",
          description: "",
          color: "",
          icon: "",
        };
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "Failed to create app.");
        this.creating = false;
      } finally {
      }
    },
    resetDialog() {
      this.localDialog = false; // Sluit de dialoog
      this.app = {
        name: "",
        description: "",
        color: "",
        icon: "",
      };
    },
  },
};
</script>
